(function(){
  function place(){
    var up=document.getElementById('UpsellsBlock--bundle_addons');
    var cont=document.querySelector('.quantity-breaks-container');
    if(!up||!cont)return;
    var checked=cont.querySelector('input:checked');
    if(!checked)return;
    var label=cont.querySelector('label[for="'+checked.id+'"]');
    if(!label)return;
    cont.querySelectorAll('label.quantity-break').forEach(function(l){l.classList.remove('lv-open');});
    label.classList.add('lv-open');
    if(label.nextElementSibling!==up){label.after(up);}
    var cs=getComputedStyle(label);
    up.style.setProperty('--lv-border',cs.borderTopColor);
    up.style.setProperty('--lv-bg',cs.backgroundColor);
    up.style.setProperty('--lv-bw',cs.borderTopWidth);
    up.style.setProperty('--lv-r',cs.borderBottomLeftRadius);
    up.classList.add('lv-addons-in-card');
  }
  function init(){
    var cont=document.querySelector('.quantity-breaks-container');
    if(!cont){return;}
    place();
    cont.addEventListener('change',function(){setTimeout(place,30);});
    cont.addEventListener('click',function(){setTimeout(place,60);});
    setTimeout(place,300);setTimeout(place,1000);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
